{{#each this}}
  <div class='modal_img' data-id='{{id}}'>
    <a>
      {{#if poster_path}}
        <img
          class='img'
          src='https://image.tmdb.org/t/p/w500{{poster_path}}'
          alt='{{title}}'
        />
      {{else}}
        <img
          class='img'
          src='https://media.istockphoto.com/id/911590226/uk/%D0%B2%D0%B5%D0%BA%D1%82%D0%BE%D1%80%D0%BD%D1%96-%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%BD%D1%8F/%D0%B2%D0%B5%D0%BA%D1%82%D0%BE%D1%80%D0%BD%D0%B0-%D1%96%D0%BB%D1%8E%D1%81%D1%82%D1%80%D0%B0%D1%86%D1%96%D1%8F-%D1%87%D0%B0%D1%81%D1%83-%D1%84%D1%96%D0%BB%D1%8C%D0%BC%D1%83-%D0%BA%D0%BE%D0%BD%D1%86%D0%B5%D0%BF%D1%86%D1%96%D1%8F-%D0%BA%D1%96%D0%BD%D0%BE%D0%BF%D0%BE%D1%81%D1%82%D0%B5%D1%80%D1%83-%D0%BD%D0%B0-%D1%87%D0%B5%D1%80%D0%B2%D0%BE%D0%BD%D0%BE%D0%BC%D1%83-%D0%BA%D1%80%D1%83%D0%B3%D0%BB%D0%BE%D0%BC%D1%83-%D1%82%D0%BB%D1%96.jpg?s=612x612&w=0&k=20&c=xj1wHSzUN8OEHhOo8Xa_Z7FlJLxFXPppehw0-6KnmRs='
          alt='{{title}}'
        />
      {{/if}}
      {{!-- <img
        class='img'
        src='https://image.tmdb.org/t/p/w500{{poster_path}}'
        alt='{{title}}'
      /> --}}
    </a>
  </div>
  <div class='modal_container_info'>
    <h2 class='modal_title table_styles--title'>{{title}}</h2>
    <table class='modal_table'>
      <tr>
        <td class='table_info'>Vote / Votes</td>
        <td class='table_styles'>
          <span class='table_rating table_rating--vote'>{{vote_average}}</span>
          /
          <span class='table_rating table_rating--votes'>{{vote_count}}</span>
        </td>
      </tr>
      <tr>
        <td class='table_info'>Popularity</td>
        <td class='table_styles'>{{popularity}}</td>
      </tr>
      <tr>
        <td class='table_info'>Original Title</td>
        <td class='table_styles table_styles--title'>{{original_title}}</td>
      </tr>
      <tr>
        <td class='table_info'>Genre</td>
        {{#if genre_ids}}<td class='table_styles'>{{genre_ids}}</td>{{else}}<td
            class='table_styles'
          >N/A</td>{{/if}}
      </tr>
    </table>
    <div class='modal_information'>
      <p class='information_title'>About</p>
      <p class='information_txt'>{{overview}}</p>
    </div>
    <div class='modal_btn'>
      <button class='btn_watched modal_btn-btn' data-id='{{id}}'>add to watched</button>
      <button class='btn_queue modal_btn-btn' data-id='{{id}}'>add to queue</button>
    </div>
  </div>
{{/each}}